import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CodigoPerfil } from '../constants/codigoPerfil';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SignedGuard implements CanActivate {

  constructor(private authService: AuthService, private route: Router){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const token = this.authService.getUser()
    if(!token) return true


    const profile = this.authService.getProfileSelected()

    if (profile) {
      if (profile.codigo === CodigoPerfil.MPV || profile.codigo === CodigoPerfil.ADMIN_MPV) {
        this.route.navigate(['mpv/dashboard'])
        return false
      } else if (profile.codigo === CodigoPerfil.USUARIO_FINAL) {
        this.route.navigate(['usuario-final'])
        return false
      } else if (profile.codigo === CodigoPerfil.MESA_PARTES) {
        this.route.navigate(['mesa-de-partes'])
        return false
      }  else if (profile.codigo === CodigoPerfil.ADMIN) {
        this.route.navigate(['administrador'])
        return false
      } else if (profile.codigo === CodigoPerfil.ARCHIVO_CENTRAL) {
        this.route.navigate(['archivoCentral'])
        return false
      }
    }

    // this.authService.logout()
    return true
  }

}
